import type { CSVParseConfig } from "#lib/csv-parser"
import { getSampleRows, parseCSV, type ParsedCSV } from "#lib/csv-parser"
import * as React from "react"

export function useCSVImport() {
  const [parsedCSV, setParsedCSV] = React.useState<ParsedCSV | null>(null)
  const [isParsing, setIsParsing] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const parseFile = React.useCallback(async (file: File, config: CSVParseConfig) => {
    setIsParsing(true)
    setError(null)

    try {
      const result = await parseCSV(file, config)
      setParsedCSV(result)
      return result
    } catch (err: any) {
      const errorMessage = err.message || "Failed to parse CSV file"
      setError(errorMessage)
      throw err
    } finally {
      setIsParsing(false)
    }
  }, [])

  const reset = React.useCallback(() => {
    setParsedCSV(null)
    setError(null)
    setIsParsing(false)
  }, [])

  const sampleRows = React.useMemo(() => {
    if (!parsedCSV) return []
    return getSampleRows(parsedCSV, 10)
  }, [parsedCSV])

  return {
    parsedCSV,
    sampleRows,
    isParsing,
    error,
    parseFile,
    reset,
  }
}
